import {
  createFileRoute,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { Chatbot } from "~/components/chatbot";
import Footer from "~/components/footer";
import { Header } from "~/components/header";
import { ScrollToTop } from "~/components/scroll-to-top";
import { getNavbarLinks } from "~/lib/constants/navbar";

export const Route = createFileRoute("/(public)")({
  component: LayoutComponent,
});

/**
 * The home route, which lays out its own bands on a white ground.
 *
 * Matched on `routeId`, not pathname, so the locale prefix (`/lv/`) is
 * irrelevant. Every other public route is `inside`: the same world in the
 * third rendition — white ground, cooler hairlines, a header with no rule
 * under it.
 */
const HOME_ROUTE_ID = "/(public)/";

type Shell = "home" | "inside";

function LayoutComponent() {
  const shell = useRouterState({
    select: (state): Shell =>
      state.matches.some((match) => match.routeId === HOME_ROUTE_ID)
        ? "home"
        : "inside",
  });

  // `ld-site` scopes the design's element defaults — p defaults to muted, a
  // drops its underline, headings zero their margins. Global they would reach
  // the showcase, the shared primitives and MDX output.
  //
  // The rendition class has to sit above the header and footer rather than
  // inside <main>, which is why the layout owns it and not the route. Every
  // route lays out its own bands, so <main> carries no measure of its own.
  return (
    <div className={`ld-site ld-${shell}`}>
      <Header links={getNavbarLinks()} />
      <ScrollToTop />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Chatbot />
    </div>
  );
}
